import Cookies from "universal-cookie";
import axios from "axios";

function getToken() {
    const cookies = new Cookies();
    return cookies.get("token");
}

const API_BASE = process.env.REACT_APP_API_BASE_URL;

/**
 * Get emotion insights analysis for a specific analysis parent
 */
export const getEmotionInsights = async (analysisParentUuid) => {
    try {
        const response = await axios.get(`${API_BASE}/analysis-parent/${analysisParentUuid}/emotion-insights`, {
            headers: {
                authorization: `Bearer ${getToken()}`
            }
        });
        
        return response.data;
    } catch (error) {
        console.error('Error fetching emotion insights:', error);
        throw error;
    }
};

/**
 * Get emotion insights analysis status for multiple analysis parents
 */
export const getEmotionInsightsStatus = async (analysisParentUuids) => {
    try {
        const response = await axios.post(`${API_BASE}/emotion-insights/status`, {
            uuids: analysisParentUuids
        }, {
            headers: {
                authorization: `Bearer ${getToken()}`,
                'Content-Type': 'application/json'
            }
        });
        
        return response.data;
    } catch (error) {
        console.error('Error fetching emotion insights status:', error);
        throw error;
    }
};

/**
 * Trigger emotion insights analysis manually
 */
export const triggerEmotionInsightsAnalysis = async (analysisParentUuid) => {
    try {
        const response = await axios.post(`${API_BASE}/analysis-parent/${analysisParentUuid}/emotion-insights/trigger`, {}, {
            headers: {
                authorization: `Bearer ${getToken()}`,
                'Content-Type': 'application/json'
            }
        });
        
        return response.data;
    } catch (error) {
        console.error('Error triggering emotion insights analysis:', error);
        throw error;
    }
};